import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { USER_BUBBLE } from './styles';

/** Lets the handoff card start a live handoff on the chat that rendered it, without threading props through. */
export const LivyLiveContext = /*#__PURE__*/createContext({
  live: null
});
export const useLivyLive = () => useContext(LivyLiveContext);

/** A line from a person on Livable's support team: their name, then what they wrote. */
export function LivyRepLine(_ref) {
  let name = _ref.name,
    content = _ref.content;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      mb: '22px'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: _objectSpread(_objectSpread({}, USER_BUBBLE), {}, {
      bgcolor: 'action.selected',
      color: 'text.primary',
      borderRadius: '16px 16px 16px 4px'
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 11.5,
      fontWeight: 600,
      color: 'text.secondary',
      mb: '2px'
    }
  }, name ? "".concat(name, " \xB7 Livable support") : 'Livable support'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      fontSize: 14,
      lineHeight: 1.5,
      whiteSpace: 'pre-wrap'
    }
  }, content)));
}

/** A handoff event (someone joined, left), centred and quiet. */
export function LivyEventLine(_ref2) {
  let content = _ref2.content;
  return /*#__PURE__*/React.createElement(Typography, {
    role: "status",
    sx: {
      textAlign: 'center',
      fontSize: 12.5,
      color: 'text.secondary',
      mb: '18px'
    }
  }, content);
}
const BANNER = {
  waiting: () => 'Asking someone from Livable support to join. Stay here; they will reply in this chat.',
  joined: name => "".concat(name || 'Someone from Livable support', " is in the chat. Livy is paused until they leave.")
};

/** Above the composer while a person is asked for or in the chat. */
export function LivyLiveBanner(_ref3) {
  let live = _ref3.live;
  if (!live || live.state !== 'waiting' && live.state !== 'joined') return null;
  return /*#__PURE__*/React.createElement(Box, {
    role: "status",
    sx: {
      mb: '10px',
      px: '12px',
      py: '8px',
      borderRadius: '8px',
      border: 1,
      borderColor: 'divider',
      bgcolor: 'action.hover'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 13
    }
  }, BANNER[live.state](live.agentName)));
}